import React from 'react'
import { useIntl } from 'react-intl'
import { RouteRow } from '../../../../components/layout'
import { TextAreaInput } from '../../../../components/layout/form/input'
import { Styling } from '../../../../components/Styling'
import { AutoliittoSeparatorLine, RouteColumn } from './subforms/styled'
import { routeSubformMessages } from './subforms/messages'

interface RouteNoteProps {
  removeLine?: boolean
}

export const RouteNotes: React.FunctionComponent<RouteNoteProps> = ({ removeLine }) => {
  const intl = useIntl()
  return (
    <>
      {!removeLine && <AutoliittoSeparatorLine marginTop="1.5rem" marginBottom="1.5rem" />}
      {removeLine && <Styling padding="1.5rem 0 0 0" />}
      <RouteRow columns="1fr">
        <RouteColumn>
          <TextAreaInput name="notes" label={intl.formatMessage(routeSubformMessages.notes)} />
        </RouteColumn>
      </RouteRow>
    </>
  )
}
